module.exports = __webpack_public_path__ + "media/images/bz-partner-locating-22019168051aee1a8374ce2591527d01.png";